/**
 * Metoda globalna pobierającą odpowiednie tłumaczenie dla komponentu Vue
 * Uwaga! Po dodaniu nowego tłumaczenia do komponentu Vue należy wykonać komendę zrzucającą tłumaczenia do plików .json
 * @php artisan translatable:export pl,en
 * Po zrzuceniu tłumaczenia do plików i dodaniu odpowiedniej translacji należy przekompilować Webpack'a by nowe
 * translacje były widoczne w komponentach Vue
 *
 * @param text
 * @param args
 * @returns {*}
 */
Vue.prototype.$lang = (text, args) => {
    var langCode = document.documentElement.lang;
    if (window[langCode] && window[langCode][text]) {
        var value = window[langCode][text];
        _.eachRight(args, (paramVal, paramKey) => {
            value = _.replace(value, `:${paramKey}`, paramVal);
        });
        return value;
    }
    return text;
};



